import { render } from "./SignalDialog.vue?vue&type=template&id=556d440c&ts=true"
import script from "./SignalDialog.vue?vue&type=script&lang=ts"
export * from "./SignalDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__